import React from 'react'
import { NavDropdown, NavLinkItem, NavWhatsApp } from './NavDropdown'

// Desktop nav extras for the personal trainer section. The first menu was also
// labelled "Services", duplicating IndexNav's site-wide Services menu; it lists
// training formats, so it is "Training".
const TRAINING = [
    { href: '/sg/personal-trainer/1-on-1-personal-training', label: '1-on-1 Personal Training' },
    { href: '/sg/personal-trainer/buddy-training', label: 'Buddy Training' },
    { href: '/sg/personal-trainer/private-home-trainer', label: 'Home Personal Trainer' },
    { href: '/sg/personal-trainer/corporate-training', label: 'Corporate Training' },
    { href: '/sg/blogs/health-fitness/ippt-personal-trainer-singapore', label: 'IPPT Preparation' },
]

const TRAINERS = [
    { href: '/sg/personal-trainer/personal-trainer-singapore-female', label: 'Female Trainer' },
    { href: '/sg/personal-trainer/freelance-personal-trainer-singapore', label: 'Freelance Trainer' },
    { href: '/sg/personal-trainer/weight-loss-trainer', label: 'Trainer for Weight Loss' },
    { href: '/sg/personal-trainer/body-building-trainer', label: 'Trainer for Muscle Gain' },
    { href: '/sg/personal-trainer/prenatal-postpartum-training', label: 'Prenatal & Postpartum Trainer' },
    { href: '/sg/personal-trainer/personal-trainer-for-elderly', label: 'Trainer for Elderly' },
    { href: '/sg/personal-trainer/personal-trainer-for-functional-fitness', label: 'Functional Fitness Trainer' },
]

export const TrainerNavBar = () => (
    <>
        <NavDropdown label="Training" items={TRAINING} />
        <NavDropdown label="Trainers" items={TRAINERS} />
        <NavLinkItem href="/sg/personal-trainer/packages" label="Packages" ariaLabel="StringsSG Personal Training Packages" />
        <NavLinkItem href="/sg/personal-trainer/personal-trainer-rates-singapore" label="Rates" ariaLabel="Personal Trainer Rates" />
        <NavLinkItem href="/sg/personal-trainer/careers" label="Careers" ariaLabel="Personal Trainer Careers" />
        <NavLinkItem href="/sg/blogs/health-fitness" label="Blogs" ariaLabel="Health & Fitness Blogs" />
        <NavWhatsApp text="Hi, I'd like to book a personal trainer." ariaLabel="WhatsApp StringsSG to book a personal trainer" />
    </>
)
